module.exports = __webpack_public_path__ + "img/Android_Male_Happy_talk_.ea2929e5.png";